import React, {useState} from 'react';
import {NavBar} from 'Components/Nav/NavBar';
import Button from 'react-bootstrap/Button';
import {TextInput} from 'Input/Input';
import {push} from 'Utils/validation';
import s from './styles/Login.module.scss';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Form from 'react-bootstrap/Form'
import PropTypes from "prop-types";
import {setSessionCookie} from "../Utils/sessions";
import {AdminApi} from "../Api/AdminApi";

export const LoginForm = ({userType, onSuccess}) => {
    const [request, setRequest] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(false)

    const keyDown = (event) => {
        if (event.key === "Enter" && !!request && !!request.email && request.email.length > 0) {
            handleSubmit();
        }
    }

    function handleSubmit() {
        setLoading(true)
        setFormErrors({});

        const errors = validate(request);
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            setLoading(false)
            return;
        }

        AdminApi.Auth.authenticateUser(request).then((res) => {
            setLoading(false)
            let user = res.data?.user;
            user.jwt = res.data?.jwt;
            setSessionCookie(user);
        }).then(() => {
            onSuccess()
        }).catch((err) => {
            setLoading(false)
            if (err.response && err.response.status >= 400 && err.response.status < 500) {
                setFormErrors({ password: 'Incorrect email or password' });
            } else {
                setFormErrors({ password: 'Unable to login. Please contact support if error persists' });
            }
        });
    }

    function validate(req) {
        const errors = {};

        if (!req.email) {
            push(errors, 'email', 'Valid email is required');
        }
        if (!req.password) {
            push(errors, 'password', 'Password is required');
        }
        return errors;
    }


    function handleChange(event) {
        const { name, value } = event.target;
        setRequest((prevState) => ({ ...prevState, [name]: value }));
    }

    function handleKeyPress(event) {
        if (event.key === 'Enter') {
            handleSubmit();
        }
    }

    return (
        <div className={s.form}>
            <h2>{userType === 'partner' ? 'Partner' : (userType === 'employer' ? 'Employer' : (userType === 'student' ? '' : ''))} Log
                In</h2>
            <p>
                Dont have an account? {' '}
                <a className='btnLink' href="/register">Register Now</a>
            </p>
            <Form>
                <TextInput containerClassName='mb-1' type="email" errors={formErrors} name="email" value={request.email || ''}
                           onKeyPress={handleKeyPress} onChange={handleChange} label="Email"/>
                <div onKeyDown={keyDown}>
                    <TextInput containerClassName='mb-3' type="password" errors={formErrors} name="password"
                               onKeyPress={handleKeyPress} value={request.password || ''} onChange={handleChange}
                               label="Password"/>
                </div>
            </Form>
            <p>
                Forgot password? {' '}
                <a className='btnLink' href="/recover">Recover your account</a>
            </p>
            <Button onClick={handleSubmit} disabled={loading}
                    className="btnFill md d-block">{loading ? "Loading..." : "Login"}</Button>
        </div>
    )
}

LoginForm.propTypes = {
    userType: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
};

const Login = () => {
    const [userType, setUserType] = useState('student');

    function onSuccess() {
        window.location.href = '/dashboard';
    }

    return (
        <>
            <NavBar dark={true}/>

            <div className={s.login}>
                {!userType ?
                    <div className='mx-auto' style={{maxWidth:'500px', marginTop:'18%'}}>
                        <h3 className='text-center fs-20 mb-2'>I am a ...</h3>
                        <Button className='btnFill md my-3 d-block wide' onClick={()=> setUserType('student')}>High School Student</Button>
                        <Button className='btnFill md my-3 d-block wide green' onClick={()=> setUserType('student')}>College Mentor</Button>
                        <Button className='btnOutline md my-3 d-block wide' onClick={()=> {
                            window.location.href = '/partners'
                        }}>NXSTEP Partner</Button>
                    </div>
                    :
                    <>
                        <LoginForm userType={userType} onSuccess={onSuccess}/>
                    </>}
            </div>
            <ToastContainer theme="dark" autoClose={false} position="bottom-center" />
        </>
    );
};

export default (Login);
